<template>
  <div>
    <contentwrapper></contentwrapper>
  </div>
</template>

<script>
'use strict'
export default {
  data: function() {
    return {}
  },
  computed: {},
  mounted: function() {},
  methods: {}
}
</script>


